import { render, staticRenderFns } from "./ValoresCartera.vue?vue&type=template&id=1f00ee80&scoped=true&"
import script from "./ValoresCartera.vue?vue&type=script&lang=js&"
export * from "./ValoresCartera.vue?vue&type=script&lang=js&"
import style0 from "./ValoresCartera.vue?vue&type=style&index=0&id=1f00ee80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f00ee80",
  null
  
)

export default component.exports